var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"Blog"}}),_c('router-view',{attrs:{"blogPosts":_vm.blogPosts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }